// framer-motion does not work in ie11, so we do
import React from 'react';

// not use it and just skip animating instead
let motion;
if (process.browser && !('ActiveXObject' in window)) {
  motion = require('framer-motion').motion;
}

const EditorBlockAdderAnimate = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return motion ? (
    <motion.div layout={true}>{children}</motion.div>
  ) : (
    <div>{children}</div>
  );
};

export default EditorBlockAdderAnimate;
